export const criteria = {
  adult: {
    eye: [
      { val: 4, label: 'Espontânea', desc: 'Abre os olhos sem estímulo' },
      { val: 3, label: 'Ao som', desc: 'Abre os olhos após pedido em voz alta' },
      { val: 2, label: 'À pressão', desc: 'Abre os olhos após estímulo de pressão' },
      { val: 1, label: 'Ausente', desc: 'Não abre os olhos' },
      { val: 'NT', label: 'Não Testável (NT)', desc: 'Olhos fechados por inchaço ou trauma' }
    ],
    verbal: [
      { val: 5, label: 'Orientada', desc: 'Sabe quem é, onde está e o ano/mês' },
      { val: 4, label: 'Confusa', desc: 'Responde, mas desorientado no tempo/espaço' },
      { val: 3, label: 'Palavras', desc: 'Palavras soltas, inteligíveis' },
      { val: 2, label: 'Sons', desc: 'Gemidos, sons incompreensíveis' },
      { val: 1, label: 'Ausente', desc: 'Sem resposta verbal' },
      { val: 'NT', label: 'Não Testável (NT)', desc: 'Intubado, traqueostomia, barreira de idioma' }
    ],
    motor: [
      { val: 6, label: 'Obedece comandos', desc: 'Executa ações simples pedidas' },
      { val: 5, label: 'Localiza', desc: 'Leva a mão acima da clavícula ao estímulo' },
      { val: 4, label: 'Flexão normal', desc: 'Dobra o braço rapidamente ao estímulo' },
      { val: 3, label: 'Flexão anormal', desc: 'Dobra o braço lentamente, padrão espástico' },
      { val: 2, label: 'Extensão', desc: 'Estica o braço ao estímulo (descerebração)' },
      { val: 1, label: 'Ausente', desc: 'Sem movimento' },
      { val: 'NT', label: 'Não Testável (NT)', desc: 'Sedação profunda, bloqueio neuromuscular, lesão medular' }
    ]
  },
  pediatric: {
    eye: [
      { val: 4, label: 'Espontânea', desc: 'Abre os olhos espontaneamente' },
      { val: 3, label: 'À fala', desc: 'Abre aos comandos ou estímulo verbal' },
      { val: 2, label: 'À dor', desc: 'Abre apenas com estímulo doloroso' },
      { val: 1, label: 'Ausente', desc: 'Não abre os olhos' },
      { val: 'NT', label: 'Não Testável (NT)', desc: 'Inchaço ou limitação física' }
    ],
    verbal: [
      { val: 5, label: 'Sorri, interage', desc: 'Balbucia apropriadamente, segue objetos' },
      { val: 4, label: 'Choro consolável', desc: 'Chora, mas é consolável' },
      { val: 3, label: 'Choro persistente', desc: 'Choro inapropriado, não consolável' },
      { val: 2, label: 'Gemidos', desc: 'Sons de dor, gemência' },
      { val: 1, label: 'Ausente', desc: 'Sem resposta' },
      { val: 'NT', label: 'Não Testável (NT)', desc: 'Intubado ou barreira física' }
    ],
    motor: [
      { val: 6, label: 'Movimentação normal', desc: 'Movimentos espontâneos e com propósito' },
      { val: 5, label: 'Retira ao toque', desc: 'Retira membro ao toque' },
      { val: 4, label: 'Retira à dor', desc: 'Retira rapidamente à dor' },
      { val: 3, label: 'Flexão anormal', desc: 'Decorticação' },
      { val: 2, label: 'Extensão', desc: 'Descerebração' },
      { val: 1, label: 'Ausente', desc: 'Flácido, sem resposta' },
      { val: 'NT', label: 'Não Testável (NT)', desc: 'Sedação, bloqueio neuromuscular' }
    ]
  }
};